import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AdminSidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Helper function to set 'active' class on current route
  const isActive = (path) => {
    return currentPath === path;
  };

  // Close sidebar when a link is clicked (on mobile)
  const handleLinkClick = () => {
    if (onClose) onClose();
  };

  return (
    <>
      {/* Sidebar wrapper with conditional open class for mobile sliding */}
      <div
        id="admin-sidebar"
        className={`sidebar-wrapper ${isOpen ? 'open' : ''} pb-5`}
        aria-hidden={!isOpen}
        tabIndex={isOpen ? 0 : -1}
        role="navigation"
        aria-label="Admin Sidebar Navigation"
      >
        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              <li className="menu-title"> <span>Main</span></li>

              <li className={isActive('/admin/dashboard') ? 'active' : ''}>
                <Link to="/admin/dashboard" onClick={handleLinkClick}>
                  <i className="fe fe-home" /> <span>Dashboard</span>
                </Link>
              </li>
              <li className={isActive('/admin/appointments') ? 'active' : ''}>
                <Link to="/admin/appointments" onClick={handleLinkClick}>
                  <i className="fe fe-layout" />  <span style={{ marginLeft: '5px' }}>Appointments</span>
                </Link>
              </li>
              <li className={isActive('/admin/specialities') ? 'active' : ''}>
                <Link to="/admin/specialities" onClick={handleLinkClick}>
                  <i className="fe fe-users" />  <span style={{ marginLeft: '5px' }}>Specialities</span>
                </Link>
              </li>
              <li className={isActive('/admin/doctors') ? 'active' : ''}>
                <Link to="/admin/doctors" onClick={handleLinkClick}>
                  <i className="fe fe-user-plus" />  <span style={{ marginLeft: '5px' }}>Doctors</span>
                </Link>
              </li>
              <li className={isActive('/admin/patients') ? 'active' : ''}>
                <Link to="/admin/patients" onClick={handleLinkClick}>
                  <i className="fe fe-user" />  <span style={{ marginLeft: '5px' }}>Patients</span>
                </Link>
              </li>
              <li className={isActive('/admin/reviews') ? 'active' : ''}>
                <Link to="/admin/reviews" onClick={handleLinkClick}>
                  <i className="fe fe-star-o" />  <span style={{ marginLeft: '5px' }}>Reviews</span>
                </Link>
              </li>
              <li className={isActive('/admin/transactions') ? 'active' : ''}>
                <Link to="/admin/transactions" onClick={handleLinkClick}>
                  <i className="fe fe-activity" />  <span style={{ marginLeft: '5px' }}>Transactions</span>
                </Link>
              </li>

              <li className={isActive('/admin/payouts') ? 'active' : ''}>
                <Link to="/admin/payouts" onClick={handleLinkClick}>
                  <i className="fas fa-dollar-sign"></i>
                   <span style={{ marginLeft: '5px' }}>Doctor Payouts</span>
                </Link>
              </li>
              <li className={isActive('/admin/blog-page') ? 'active' : ''}>
                <Link to="/admin/blog-page" onClick={handleLinkClick}>
                  <i className="fas fa-blog"></i>
                   <span style={{ marginLeft: '5px' }}>Blogs</span>
                </Link>
              </li>
              <li className={isActive('/admin/AllOffers') ? 'active' : ''}>
                <Link to="/admin/AllOffers" onClick={handleLinkClick}>
                  <i className="fe fe-tag" />
                   <span style={{ marginLeft: '5px' }}>Offers</span>
                </Link>
              </li>
               <li className={isActive('/admin/currency-settings') ? 'active' : ''}>
                <Link to="/admin/currency-settings" onClick={handleLinkClick}>
                 <i class="bi bi-currency-exchange"></i>
                   <span style={{ marginLeft: '6px' }}>Currency</span>
                </Link>
              </li>
              <li className={isActive('"/admin/settings"') ? 'active' : ''}>
                <Link to="/admin/settings" onClick={handleLinkClick}>
                <i class="bi bi-gear"></i>
                   <span style={{ marginLeft: '6px' }}>Platform Charges</span>
                </Link>
              </li>
              <li className={isActive('/admin/NotificationSettings') ? 'active' : ''}>
                <Link to="/admin/NotificationSettings" onClick={handleLinkClick}>
                  <i className="fe fe-bell" />
                   <span style={{ marginLeft: '5px' }}>Notification Settings</span>
                </Link>
              </li>
              <li className={isActive('/admin/admin-business') ? 'active' : ''}>
                <Link to="/admin/admin-business" onClick={handleLinkClick}>
                  <i className="fe fe-bar-chart" />
                   <span style={{ marginLeft: '5px' }}>Business Settings</span>
                </Link>
              </li>
              <li className={isActive('/admin/PaymentSettings') ? 'active' : ''}>
                <Link to="/admin/PaymentSettings" onClick={handleLinkClick}>
                  <i className="bi bi-credit-card" />
                  <span style={{ marginLeft: '5px' }}>Payment Settings</span>
                </Link>
              </li>
              <li className={isActive('/admin/VideoSettings') ? 'active' : ''}>
                <Link to="/admin/VideoSettings" onClick={handleLinkClick}>
                  <i className="bi bi-credit-card" />
                  <span style={{ marginLeft: '5px' }}>Video Settings</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar Overlay */}
      {isOpen && (
        <div
          className="mobile-sidebar-overlay show d-lg-none"
          onClick={onClose}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default AdminSidebar;
